const MOTION_STEP_EPSILON_MS = 0.0001;

function turnDirection(left, right) {
  if (left && !right) return -1;
  if (right && !left) return 1;
  return 0;
}

// Advance a predicted pose with the same angle-then-position integration used
// by the authoritative engine. Long prediction windows are split into tick-
// sized pieces so a 100+ ms network lead does not collapse an entire turn into
// one overly sharp chord.
function advancePredictedPose(pose, {
  dtMs,
  left = false,
  right = false,
  speed,
  turnRadius,
  maxStepMs
} = {}) {
  if (!pose || typeof pose !== 'object') return pose;

  const parsedDtMs = Number(dtMs);
  let remainingMs = Number.isFinite(parsedDtMs) ? Math.max(0, parsedDtMs) : 0;
  const parsedSpeed = Number(speed);
  const speedPxPerSec = Number.isFinite(parsedSpeed) ? Math.max(0, parsedSpeed) : 0;
  const parsedRadius = Number(turnRadius);
  const radius = Number.isFinite(parsedRadius) ? Math.max(0.0001, parsedRadius) : 0.0001;
  const parsedStepLimitMs = Number(maxStepMs);
  const stepLimitMs = Number.isFinite(parsedStepLimitMs) && parsedStepLimitMs > MOTION_STEP_EPSILON_MS
    ? parsedStepLimitMs
    : (remainingMs || MOTION_STEP_EPSILON_MS);
  const dir = turnDirection(Boolean(left), Boolean(right));

  let x = Number(pose.x) || 0;
  let y = Number(pose.y) || 0;
  let angle = Number(pose.angle) || 0;

  while (remainingMs > MOTION_STEP_EPSILON_MS) {
    const stepMs = Math.min(remainingMs, stepLimitMs);
    const stepSeconds = stepMs / 1000;
    angle += dir * (speedPxPerSec / radius) * stepSeconds;
    const distance = speedPxPerSec * stepSeconds;
    x += Math.cos(angle) * distance;
    y += Math.sin(angle) * distance;
    remainingMs -= stepMs;
  }

  pose.x = x;
  pose.y = y;
  pose.angle = angle;
  return pose;
}

export {
  advancePredictedPose,
  turnDirection
};
